export default "__VITE_ASSET__Dgz3jVk7__"